import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/images/jobs/claim-success.gif'


const _hoisted_1 = { class: "px-3" }
const _hoisted_2 = { class: "box has-text-centered" }
const _hoisted_3 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("img", { src: _imports_0 }, null, -1)),
      _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
      _cache[5] || (_cache[5] = _createElementVNode("span", { class: "bold-text" }, "Yay! This job is complete", -1)),
      _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
      _cache[7] || (_cache[7] = _createElementVNode("div", null, "Our team will review your findings and may reach out with next steps.", -1)),
      _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)),
      (_ctx.showAllJobs)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _cache[1] || (_cache[1] = _createElementVNode("div", null, "In the meantime, check out other available jobs below.", -1)),
            _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
            _createElementVNode("button", {
              class: "button is-primary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.close({seeAll: true})))
            }, "See all jobs")
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}